(function () {
  (function initHeroMedia() {
    var mq = window.matchMedia("(max-width: 900px)");
    var hero = document.querySelector(".bp-hero");
    if (!hero) return;

    var videos = hero.querySelectorAll("video.bp-hero__media");
    if (!videos.length) return;

    function visibleHeroVideo() {
      var desktop = hero.querySelector("video.bp-hero__media--desktop");
      var mobile = hero.querySelector("video.bp-hero__media--mobile");
      if (mq.matches && mobile) return mobile;
      return desktop || videos[0];
    }

    function playHeroVideo(heroVideo) {
      if (!heroVideo || heroVideo.tagName !== "VIDEO") return;
      heroVideo.muted = true;
      heroVideo.setAttribute("playsinline", "");
      heroVideo.setAttribute("autoplay", "");
      if (heroVideo.readyState < 2) {
        heroVideo.preload = "auto";
        heroVideo.load();
      }
      function start() {
        var p = heroVideo.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (heroVideo.readyState >= 2) {
        start();
      } else {
        heroVideo.addEventListener("canplay", start, { once: true });
      }
    }

    function syncHeroPlayback() {
      var active = visibleHeroVideo();
      videos.forEach(function (v) {
        if (v === active) playHeroVideo(v);
        else v.pause();
      });
    }

    syncHeroPlayback();

    if (mq.addEventListener) mq.addEventListener("change", syncHeroPlayback);
    else if (mq.addListener) mq.addListener(syncHeroPlayback);

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) syncHeroPlayback();
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        videos.forEach(function (v) { v.pause(); });
        return;
      }
      syncHeroPlayback();
    });
  })();

  document.querySelectorAll(".bp-role-item.is-hiring details").forEach(function (item) {
    item.open = false;
  });

  var sheet = document.getElementById("bp-role-sheet");
  var sheetBody = document.getElementById("bp-role-sheet-body");
  var brief = document.querySelector(".bp-role-item.is-hiring .bp-role-more__body");
  function isPhone() {
    return window.matchMedia("(max-width: 900px)").matches;
  }
  var hiringCard = document.querySelector(".bp-role-item.is-hiring");
  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.style.overflow = "";
    if (hiringCard) hiringCard.classList.remove("is-open");
  }
  function openSheet() {
    if (!sheet) return;
    if (sheetBody && brief && !sheetBody.childElementCount) {
      sheetBody.appendChild(brief.cloneNode(true));
    }
    sheet.hidden = false;
    document.documentElement.style.overflow = "hidden";
    if (hiringCard) hiringCard.classList.add("is-open");
  }
  document.querySelectorAll(".bp-role-item.is-hiring summary").forEach(function (summary) {
    summary.addEventListener("click", function (event) {
      if (!isPhone()) return;
      event.preventDefault();
      openSheet();
    });
  });
  document.querySelectorAll("[data-bp-sheet-close]").forEach(function (el) {
    el.addEventListener("click", closeSheet);
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeSheet();
  });

  function roleSelectField() {
    var form = document.getElementById("bp-application");
    return form ? form.querySelector("[data-bp-role-select]") : null;
  }

  function syncRoleOtherFields() {
    var form = document.getElementById("bp-application");
    if (!form) return;
    var sel = form.querySelector("[data-bp-role-select]");
    var wrap = document.getElementById("bp-role-custom-wrap");
    var custom = document.getElementById("bp-role-custom");
    if (!sel || !wrap || !custom) return;
    var isOther = sel.value === "Other";
    wrap.classList.toggle("is-open", isOther);
    wrap.hidden = !isOther;
    wrap.setAttribute("aria-hidden", isOther ? "false" : "true");
    if (isOther) {
      sel.removeAttribute("name");
      sel.required = false;
      custom.setAttribute("name", "Role");
      custom.required = true;
    } else {
      custom.removeAttribute("name");
      custom.required = false;
      custom.value = "";
      sel.setAttribute("name", "Role");
      sel.required = true;
    }
  }

  function selectRole(label) {
    var field = roleSelectField();
    if (!field || !label) return;
    var needle = String(label).toLowerCase();
    Array.prototype.forEach.call(field.options || [], function (option) {
      if (!option.value || option.value === "Other") return;
      if (option.value.toLowerCase().indexOf(needle) !== -1 || option.text.toLowerCase().indexOf(needle) !== -1) {
        field.value = option.value;
      }
    });
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function goApply(label) {
    closeSheet();
    selectRole(label);
    var apply = document.getElementById("apply");
    if (apply) apply.scrollIntoView({ behavior: "smooth", block: "start" });
    var name = document.querySelector('#bp-application [name="Name"]');
    if (name) {
      window.setTimeout(function () {
        name.focus({ preventScroll: false });
      }, 350);
    }
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest("[data-bp-role]");
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    goApply(link.getAttribute("data-bp-role"));
  });

  document.querySelectorAll(".bp-role-item.is-later details").forEach(function (item) {
    item.open = false;
    item.addEventListener("toggle", function () {
      item.open = false;
    });
  });

  document.querySelectorAll(".bp-role-item details").forEach(function (item) {
    item.addEventListener("toggle", function () {
      if (isPhone()) {
        item.open = false;
        return;
      }
      document.querySelectorAll(".bp-role-item details[open]").forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });

  var form = document.getElementById("bp-application");
  if (form) {
    var roleSelect = form.querySelector("[data-bp-role-select]");
    if (roleSelect) {
      roleSelect.addEventListener("change", function () {
        syncRoleOtherFields();
        if (roleSelect.value === "Other") {
          var customField = document.getElementById("bp-role-custom");
          if (customField) customField.focus({ preventScroll: true });
        }
      });
      syncRoleOtherFields();
    }
    var clientError = document.getElementById("bp-form-client-error");
    var submit = form.querySelector("[type=submit]");
    form.addEventListener("invalid", function (event) {
      if (!clientError) return;
      clientError.hidden = false;
      var label = event.target.closest("label");
      var name = label ? label.childNodes[0].textContent.trim() : "a required field";
      clientError.textContent = "Missing: " + name + ". Complete that, then submit again.";
    }, true);
    form.addEventListener("submit", function (event) {
      if (clientError) clientError.hidden = true;
      if (form.getAttribute("data-preview") === "true") {
        event.preventDefault();
        if (submit) {
          submit.disabled = true;
          submit.textContent = "Sent (preview)";
        }
        var ok = document.createElement("p");
        ok.className = "bp-form-status bp-form-status--ok";
        ok.setAttribute("role", "status");
        ok.textContent = "We heard you. Expect a founder reply within two weeks if there is a strong fit.";
        form.insertBefore(ok, form.querySelector(".bp-form-head").nextSibling);
        return;
      }
      event.preventDefault();
      if (submit) {
        submit.disabled = true;
        submit.setAttribute("aria-busy", "true");
        submit.textContent = "Sending…";
      }
      var honey = form.querySelector('[name="_honey"]');
      if (honey && honey.value.trim()) return;

      var inboxEl = document.getElementById("bp-careers-inbox");
      var inbox = (inboxEl && inboxEl.value.trim()) || "careers@bulletproofculture.com";
      var payload = new FormData(form);
      payload.delete("_honey");
      var applicantEmail = form.querySelector('[name="email"]');
      var roleField = form.querySelector('[name="Role"]');
      var roleLabel = roleField && roleField.value ? roleField.value : "application";
      payload.set("_subject", "Bulletproof Culture careers — " + roleLabel);
      payload.set("_template", "table");
      payload.set("_captcha", "false");
      if (applicantEmail && applicantEmail.value) payload.set("_replyto", applicantEmail.value);

      function showFormStatus(ok, message) {
        var status = document.createElement("p");
        status.className = "bp-form-status " + (ok ? "bp-form-status--ok" : "bp-form-status--error");
        status.setAttribute("role", ok ? "status" : "alert");
        status.textContent = message;
        var head = form.querySelector(".bp-form-head");
        form.insertBefore(status, head ? head.nextSibling : form.firstChild);
        if (submit) {
          submit.disabled = !ok;
          submit.removeAttribute("aria-busy");
          submit.textContent = ok ? "Application sent" : "Submit application ↗";
        }
      }

      fetch("https://formsubmit.co/ajax/" + encodeURIComponent(inbox), {
        method: "POST",
        headers: { Accept: "application/json" },
        body: payload
      }).then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body || {} };
        }).catch(function () {
          return { ok: response.ok, body: {} };
        });
      }).then(function (result) {
        var body = result.body || {};
        var apiMessage = typeof body.message === "string" ? body.message : "";
        var failed = body.success === false || body.success === "false" || !result.ok;
        if (!failed) {
          showFormStatus(true, "We heard you. Expect a founder reply within two weeks if there is a strong fit.");
          return;
        }
        if (/activat/i.test(apiMessage)) {
          showFormStatus(
            false,
            "First-time setup: open " + inbox + " (and spam/quarantine) for an email from FormSubmit.co, click Activate Form, then submit again. Shopify does not send these — FormSubmit delivers them."
          );
          return;
        }
        showFormStatus(
          false,
          apiMessage ||
            "Could not send just then. Email " + inbox + " directly, or try again after FormSubmit activation."
        );
      }).catch(function () {
        showFormStatus(
          false,
          "Could not send just then. Check " + inbox + " for a FormSubmit.co activation email (including spam), confirm it, then submit again."
        );
      });
    });
  }

  if (new URLSearchParams(window.location.search).get("application") === "sent") {
    var serverOk = document.getElementById("bp-form-server-success");
    if (serverOk) serverOk.hidden = false;
    var applySection = document.getElementById("apply");
    if (applySection) applySection.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  var params = new URLSearchParams(window.location.search);
  var fromQuery = params.get("role");
  var path = window.location.pathname.toLowerCase();
  if (fromQuery) selectRole(fromQuery);
  else if (path.indexOf("operation") !== -1 || document.body.className.indexOf("careers-operations") !== -1) {
    selectRole("operations");
  }

  if (fromQuery || path.indexOf("operation") !== -1 || window.location.hash === "#apply") {
    goApply(fromQuery || "operations");
  }

  var live = document.querySelector("[data-bp-live]");
  if (live && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var countEl = live.querySelector("[data-bp-live-count]");
    var pctEl = live.querySelector("[data-bp-live-pct]");
    var bar = live.querySelector(".bp-progress__bar");
    var fill = live.querySelector(".bp-progress__fill");
    var target = parseInt(live.getAttribute("data-current"), 10) || 0;
    var goal = parseInt(live.getAttribute("data-goal"), 10) || 1;
    var slowAt = parseInt(live.getAttribute("data-slow-at"), 10) || 28000;
    var tickMs = parseInt(live.getAttribute("data-tick-ms"), 10) || 30000;
    var n = 0;
    function paint(animateBar) {
      var pct = Math.min(100, (n / goal) * 100);
      if (countEl) countEl.textContent = Math.round(n).toLocaleString("en-GB");
      if (pctEl) pctEl.textContent = Math.floor(pct) + "%";
      if (fill && animateBar !== false) fill.style.width = pct + "%";
      if (bar) bar.setAttribute("aria-valuenow", String(Math.round(n)));
    }
    paint(true);
    var rampEnd = Math.min(slowAt, target);
    var t0 = performance.now();
    var rampMs = 7200;
    function easeOut(t) { return 1 - Math.pow(1 - t, 4); }
    function startSlowTicks() {
      if (n >= target) return;
      function tick() {
        if (n >= target) return;
        n += 1;
        paint(true);
        if (n < target) window.setTimeout(tick, tickMs);
      }
      window.setTimeout(tick, tickMs);
    }
    function rampFrame(now) {
      var t = Math.min(1, (now - t0) / rampMs);
      n = rampEnd * easeOut(t);
      paint(true);
      if (t < 1) {
        requestAnimationFrame(rampFrame);
        return;
      }
      n = rampEnd;
      paint(true);
      if (target <= slowAt) return;
      startSlowTicks();
    }
    if (target <= slowAt) {
      n = target;
      paint(true);
    } else {
      requestAnimationFrame(rampFrame);
    }
  }

})();
